<template>
    <div class="video-gallery">
        <div class="container">
            <div class="gallery-header">
                <h2>{{ lang.videoGalleryTips }}</h2>
                <div class="underline"></div>
            </div>
            
            <div class="videos-grid">
                <div v-for="(video, index) in videos" :key="index" class="video-card">
                    <div class="video-wrapper" @click="playVideo(video)">
                        <video 
                            :src="video.src" 
                            controls
                        ></video>
                    </div>
                    <div class="video-info">
                        <h3>{{ video.title }}</h3>
                        <p>{{ video.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VideoGallery",
    computed: {
        lang() {
            return this.$store.state.language;
        },
        videos(){
            let arr = []
            for(let i = 1; i <= this.videosNum; i++){
                let item = {}
                item.title = this.lang.videoGallery[`title${i}`]
                item.description = this.lang.videoGallery[`description${i}`]
                item.src = `video/${i}.mp4`
                arr.push(item)
            }
            return arr
        }
    },
    data() {
        return {
            videosNum: 4
        };
    },
    created(){
    },
    methods: {
        playVideo(video) {
            const videoElements = this.$el.querySelectorAll('video');
            videoElements.forEach(el => {
                if (el.src !== video.src && !el.paused) {
                    el.pause();
                }
            });
            
            const videoElement = this.$el.querySelector(`video[src="${video.src}"]`);
            if (videoElement) {
                if (videoElement.paused) {
                    videoElement.play();
                } else {
                    videoElement.pause();
                }
            }
        }
    },
};
</script>

<style scoped lang="scss">
.video-gallery {
    flex: 1;
    overflow: auto;
    padding: 40px 0;
    background-color: #f8f9fa;
    
    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }
    
    .gallery-header {
        margin-top: 40px;
        margin-bottom: 60px;
        text-align: center;
        animation: fadeIn 1s ease;
        
        h2 {
            font-size: 2.5rem;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 15px;
        }
        
        .underline {
            width: 80px;
            height: 3px;
            background: linear-gradient(to right, #3498db, #2980b9);
            margin: 0 auto;
        }
    }
    
    .videos-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
        gap: 30px;
        
        .video-card {
            background-color: white;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            opacity: 0;
            transform: translateY(30px);
            animation: fadeInUp 0.8s ease forwards;
            
            @for $i from 1 through 10 {
                &:nth-child(#{$i}) {
                    animation-delay: #{$i * 0.15}s;
                }
            }
            
            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
            }
            
            .video-wrapper {
                position: relative;
                width: 100%;
                cursor: pointer;
                
                video {
                    width: 100%;
                    display: block;
                    object-fit: cover;
                    aspect-ratio: 16 / 9;
                }
            }
            
            .video-info {
                padding: 25px;
                
                h3 {
                    font-size: 1.4rem;
                    color: #2c3e50;
                    margin-bottom: 15px;
                    font-weight: 600;
                }
                
                p {
                    color: #555;
                    font-size: 15px;
                    line-height: 1.6;
                }
            }
        }
    }
    
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @media (max-width: 992px) {
        .videos-grid {
            grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        }
    }
    
    @media (max-width: 768px) {
        padding: 30px 0;
        
        .gallery-header {
            margin-top: 30px;
            margin-bottom: 40px;
            
            h2 {
                font-size: 2rem;
            }
        }
        
        .videos-grid {
            grid-template-columns: 1fr;
            gap: 25px;
            
            .video-card {
                .video-wrapper {
                    .play-overlay {
                        .play-button {
                            width: 60px;
                            height: 60px;
                            
                            i {
                                font-size: 28px;
                            }
                        }
                    }
                }
                
                .video-info {
                    padding: 20px;
                    
                    h3 {
                        font-size: 1.3rem;
                        margin-bottom: 10px;
                    }
                    
                    p {
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>
